import React, { useContext, useState, useEffect } from "react";
import "./ChanelApp.scss";
import "react-perfect-scrollbar/dist/css/styles.css";

import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { UserContext } from "../../api/user/userContext";
import ChanelOwnerInfos from "./ChanelOwnerInfos";
import GATracker from "../components/GATracker";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Navbar } from "react-bootstrap";
import ChanelHome from "../components/ChanelHome";
import ChanelReplays from "../components/ChanelReplays";
import { Switch, Route } from "react-router-dom";
import { LoadingContext } from "../../api/loading/LoadingContext";
import XeesterUser from "../../api/user/User";
import CircleLoader from "react-spinners/CircleLoader";

function ChanelApp({
  match,
  location,
  history,
  onShowLogin,
  userChanel = false
}) {
  const { user, dispatchUser } = useContext(UserContext);
  const [owner, setOwner] = useState(null);
  const [homeData, setHomeData] = useState(null);
  const [replaysData, setReplaysData] = useState(null);
  const [chanelId, setChanelId] = useState(null);
  const [category, setCategory] = useState(null);
  const [tab, setTab] = useState("home");
  // v2-1574: the owner's selection of replays, started from the header and shown by the REPLAYS list, which ends it
  const [selecting, setSelecting] = useState(false);
  const { loading, dispatchLoading } = useContext(LoadingContext);
  const { t } = useTranslation();

  const scrollbarRef = React.createRef();

  const onDataUpdated = () => {
    if (scrollbarRef.current !== null) {
      scrollbarRef.current.updateScroll();
    }
  };

  const onVisibilityAllChanged = () => {
    // a null chanelId makes the effect below fetch the chanel again (lists and counters)
    setChanelId(null);
  };

  const onSubscribed = (response) => {
    if (response.error !== 401) {
      Object.assign(owner, { subscribed: response.subscribed });
      setOwner(owner);
      let _user = XeesterUser.from(user);
      Object.assign(_user, { subscriptions: response.subscriptions });
      dispatchUser({ type: "update", payload: _user });
    } else {
      dispatchUser({ type: "disconnect" });
    }
  };

  useEffect(() => {
    //FETCH HAND DETAILS
    //console.log("chanelApp effect", location);

    const _chanelId = match.params.id;
    const _tab = match.params.tab;
    const _category = match.params.category;

    let timeout = null;
    if (
      _chanelId !== null &&
      _chanelId.length > 0 &&
      (_chanelId !== chanelId || _tab !== tab || _category !== category)
    ) {
      console.log("fetching[" + _tab + "]! " + _chanelId);
      dispatchLoading({ type: "update", payload: 10 });
      setChanelId((c) => _chanelId);
      if (_tab !== "home" && _tab !== "replays") {
        history.push("/");
        return;
      }
      setTab((t) => _tab);
      setCategory((t) => _category);
      // another channel, tab or filter: nothing stays selected out of sight
      setSelecting(false);
      let search = location.search;
      if (search.startsWith("?")) {
        search += "&id=" + _chanelId;
      } else {
        search = "?id=" + _chanelId;
      }
      if (_category !== null) {
        search += "&category=" + _category;
      }
      let _url =
        window.serverUrl+"/social/chanel-" + _tab + ".php" + search;
      fetch(_url)
        .then((r) => r.json())
        .then((_chanelOwner) => {
          if (_chanelOwner.error === 404) {
            history.push("/");
            return;
          }
          dispatchLoading({ type: "update", payload: 50 });
          if (_tab === "home") {
            setHomeData((c) => _chanelOwner);
          } else if (_tab === "replays") {
            setReplaysData((c) => _chanelOwner);
          }
          setOwner((c) => _chanelOwner);
          timeout = setTimeout(() => {
            dispatchLoading({ type: "update", payload: 100 });
            //FETCH USER
          }, 500);
        })
        .catch((err) => {
          timeout = setTimeout(() => {
            dispatchLoading({ type: "update", payload: 100 });
          }, 500);
          history.push("/");

          console.error("fetch problem", err);
        });
    }

    return () => {
      if (timeout !== null) {
        clearTimeout(timeout);
      }
      //console.log("chanelApp done");
    };
  }, [
    chanelId,
    dispatchLoading,
    tab,
    category,
    match.params.category,
    location,
    history,
    match.params.id,
    match.params.tab
  ]);

  return (
    <>
      <GATracker></GATracker>
      {/* v2-1485 : the channel page had no container, so its toasts (e.g. the visibility-all error) never showed */}
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <PerfectScrollbar
        className="chanel-scroll user-chanel main-scroll"
        ref={scrollbarRef}
      >
        {owner !== null ? (
          <div className="chanel-owner-global-container d-flex flex-column">
            <ChanelOwnerInfos
              chanelOwner={owner}
              onShowLogin={onShowLogin}
              onSubscribed={onSubscribed}
              onVisibilityAllChanged={onVisibilityAllChanged}
              onSelect={
                // only while the list is on screen: during a reload the list is unmounted, and its return would end
                // a selection started meanwhile
                match.params.tab === "replays" &&
                loading.progress === 100 &&
                replaysData !== null &&
                replaysData.last.length > 0
                  ? () => setSelecting(true)
                  : null
              }
              selecting={selecting}
            ></ChanelOwnerInfos>
            <div className="chanel-tabs-container d-flex flex-column">
              <Navbar className="chanel-tabs">
                <NavLink
                  to={"/c/" + match.params.id + "/home"}
                  activeClassName="active"
                >
                  <span>{t("chanelApp.home")}</span>
                </NavLink>
                <NavLink
                  to={"/c/" + match.params.id + "/replays/all"}
                  activeClassName="active"
                  isActive={() => {
                    if (!match) {
                      return false;
                    }
                    return match.params.tab === "replays";
                  }}
                >
                  <span>{t("chanelApp.replays")}</span>
                </NavLink>
              </Navbar>
            </div>
          </div>
        ) : (
          <div className="loading-container">
            <CircleLoader  color="#FFF" size={150}/>
          </div>
        )}

        <div className="chanel-container d-flex flex-column">
          {owner !== null ? (
            <>
              {loading.progress === 100 ? (
                <Switch>
                  <Route
                    path="/c/:id/home"
                    render={(props) => (
                      <ChanelHome data={homeData}></ChanelHome>
                    )}
                  />
                  <Route
                    path="/c/:id/replays"
                    render={(props) => (
                      <ChanelReplays
                        location={location}
                        params={match.params}
                        startUrl={"/c/" + match.params.id + "/replays"}
                        queryUrl={
                          window.serverUrl+"/social/chanel-replays.php"
                        }
                        data={replaysData}
                        onDataUpdated={onDataUpdated}
                        onVisibilityAllChanged={onVisibilityAllChanged}
                        selecting={selecting}
                        onSelectingChanged={setSelecting}
                      ></ChanelReplays>
                    )}
                  />
                </Switch>
              ) : (
                <div className="loading-container">
                  <CircleLoader  color="#FFF" size={150}/>
                </div>
              )}
            </>
          ) : (
            <div className="loading-container">
              <CircleLoader  color="#FFF" size={150}/>
            </div>
          )}
        </div>
      </PerfectScrollbar>
    </>
  );
}
export default ChanelApp;
